'use client';

import { ListingPayload } from '@/slw/entities/seller/listing';

export function ListingOverview({ listing }: { listing: ListingPayload }) {
  return (
    <section className='px-6 '>
      <h2 className='text-2xl font-bold mb-4'>Vehicle Overview</h2>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4 text-base items-center'>
        <ul className='space-y-4 px-4 list-disc font-medium text-sm'>
          <li>
            <span>Country:</span> {listing.countryName}
          </li>
          <li>
            <span>State:</span> {listing.stateName}
          </li>
          <li>
            <span>City:</span> {listing.city}
          </li>
          <li>
            <span>ZIP code:</span> {listing.zipCode}
          </li>
        </ul>
        <ul className='space-y-4 px-4 list-disc font-medium text-sm'>
          <li>
            <span>VIN:</span> {listing.vin}
          </li>
          <li>
            <span>Year:</span> {listing.year}
          </li>
          <li>
            <span>Vehicle era:</span> {listing.vehicleEraName}
          </li>
        </ul>
      </div>
    </section>
  );
}
